import { useLocation } from 'react-router-dom';

export function useQueryParams() {
    return Object.fromEntries(
        new URLSearchParams(
            useLocation().search
        ).entries()
    );
}


// WEBPACK FOOTER //
// ./resources/assets/js/hooks/useQueryParams.js